export const iconFontAwesomeArrowsArrowsUpDownLeftRight = (
	<i className="fa-solid fa-arrows-up-down-left-right"></i>
);
